export default "__VITE_ASSET__CLUNPa1x__"